import { Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { formatDate, formatMoney } from "@/features/shared";

export const GeneralInformationSection = ({ otherPayment }) => {
  const cashBankAccount = otherPayment.cashBankOutletChartOfAccount;

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
            <Typography variant="subtitle1">Informasi Umum</Typography>
            {otherPayment.expenseId && (
              <Chip size="small" label="Dari Biaya POS" color="info" />
            )}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Kas/Bank
          </Typography>
          <Typography variant="body1">
            {cashBankAccount
              ? `${cashBankAccount.code} - ${cashBankAccount.name}`
              : "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Tanggal
          </Typography>
          <Typography variant="body1">
            {formatDate(otherPayment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Nilai
          </Typography>
          <Typography variant="body1">
            {formatMoney(otherPayment.amount || 0)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            No Cek #
          </Typography>
          <Typography variant="body1">
            {otherPayment.checkNumber || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Penerima
          </Typography>
          <Typography variant="body1">{otherPayment.payee || "-"}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Catatan
          </Typography>
          <Typography variant="body1">{otherPayment.note || "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  otherPayment: PropTypes.object.isRequired,
};
